// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GeneralSettings_tvmML {
  background-color: var(--f5-background);
  height: 100%;

  .GeneralSettingsContent_p07zs {
    display: flex;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    @media (width<=768px) {

      flex-direction: column;
      gap: 15px;
    }
    .leftGeneralSetting_XafRE {
      width: 30%;
      max-width: 180px;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin: 0 10px;
      box-sizing: border-box;
      @media (width<=768px) {
        margin: 0 10px;
        width: calc(100% - 20px);
        max-width: none;
        height: fit-content;

      }

      ul {
        gap: 10px;
        display: inline-grid;
        list-style: none;
        margin: 0;
        padding: 0;
        @media (width<=768px) {
          width: 100%;
          display: flex;
          flex-direction: row;
          overflow: scroll;
        }
        li {
          margin: 0;
          padding: 0;
          cursor: pointer;
          display: flex;
          padding: 6px 8px;
          gap: 10px;
          align-items: center;
          gap: 10px;
          min-width: 160px;

          svg {
            color: var(--_0d-color);
          }
        }

        .disabledOption_ohK5e {
          cursor: not-allowed;
          opacity: 0.6;
        }

        .getPlusOption_zi62L{
          background-color: var(--ice-balck-background);
        }
      }

      .selected_RygAl {
        border-radius: 6px;
        background: var(--ececf1-background);
      }
    }

    .rightGeneralSetting_GRkNq {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      border: 1px solid var(--ececf1-border);
      background: var(--white-color);
      padding: 8px 20px 20px 20px;
      /* padding: 8px 20px 20px 20px; */
      box-sizing: border-box;
      margin-right: 20px;
      box-sizing: border-box;
      max-height: 75vh;
      overflow-y: scroll;
      @media (width<=768px) {
        margin: 0 10px;
        height: 100vh;
        width: calc(100% - 20px);
      }
    }

    .rightGeneralSetting_GRkNq::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
    }

    .rightGeneralSetting_GRkNq {
      scrollbar-width: none;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/GeneralSettings.module.css"],"names":[],"mappings":"AAAA;EACE,sCAAsC;EACtC,YAAY;;EAEZ;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB;;MAEE,sBAAsB;MACtB,SAAS;IACX;IACA;MACE,UAAU;MACV,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,cAAc;MACd,sBAAsB;MACtB;QACE,cAAc;QACd,wBAAwB;QACxB,eAAe;QACf,mBAAmB;;MAErB;;MAEA;QACE,SAAS;QACT,oBAAoB;QACpB,gBAAgB;QAChB,SAAS;QACT,UAAU;QACV;UACE,WAAW;UACX,aAAa;UACb,mBAAmB;UACnB,gBAAgB;QAClB;QACA;UACE,SAAS;UACT,UAAU;UACV,eAAe;UACf,aAAa;UACb,gBAAgB;UAChB,SAAS;UACT,mBAAmB;UACnB,SAAS;UACT,gBAAgB;;UAEhB;YACE,uBAAuB;UACzB;QACF;;QAEA;UACE,mBAAmB;UACnB,YAAY;QACd;;QAEA;UACE,6CAA6C;QAC/C;MACF;;MAEA;QACE,kBAAkB;QAClB,oCAAoC;MACtC;IACF;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,sCAAsC;MACtC,8BAA8B;MAC9B,2BAA2B;MAC3B,iCAAiC;MACjC,sBAAsB;MACtB,kBAAkB;MAClB,sBAAsB;MACtB,gBAAgB;MAChB,kBAAkB;MAClB;QACE,cAAc;QACd,aAAa;QACb,wBAAwB;MAC1B;IACF;;IAEA;MACE,QAAQ;MACR,SAAS;MACT,aAAa;IACf;;IAEA;MACE,qBAAqB;IACvB;EACF;AACF","sourcesContent":[".GeneralSettings {\n  background-color: var(--f5-background);\n  height: 100%;\n\n  .GeneralSettingsContent {\n    display: flex;\n    height: 100%;\n    overflow: hidden;\n    box-sizing: border-box;\n    @media (width<=768px) {\n\n      flex-direction: column;\n      gap: 15px;\n    }\n    .leftGeneralSetting {\n      width: 30%;\n      max-width: 180px;\n      height: 100%;\n      display: flex;\n      flex-direction: column;\n      margin: 0 10px;\n      box-sizing: border-box;\n      @media (width<=768px) {\n        margin: 0 10px;\n        width: calc(100% - 20px);\n        max-width: none;\n        height: fit-content;\n\n      }\n\n      ul {\n        gap: 10px;\n        display: inline-grid;\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        @media (width<=768px) {\n          width: 100%;\n          display: flex;\n          flex-direction: row;\n          overflow: scroll;\n        }\n        li {\n          margin: 0;\n          padding: 0;\n          cursor: pointer;\n          display: flex;\n          padding: 6px 8px;\n          gap: 10px;\n          align-items: center;\n          gap: 10px;\n          min-width: 160px;\n\n          svg {\n            color: var(--_0d-color);\n          }\n        }\n\n        .disabledOption {\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n\n        .getPlusOption{\n          background-color: var(--ice-balck-background);\n        }\n      }\n\n      .selected {\n        border-radius: 6px;\n        background: var(--ececf1-background);\n      }\n    }\n\n    .rightGeneralSetting {\n      width: 100%;\n      height: 100%;\n      border-radius: 8px;\n      border: 1px solid var(--ececf1-border);\n      background: var(--white-color);\n      padding: 8px 20px 20px 20px;\n      /* padding: 8px 20px 20px 20px; */\n      box-sizing: border-box;\n      margin-right: 20px;\n      box-sizing: border-box;\n      max-height: 75vh;\n      overflow-y: scroll;\n      @media (width<=768px) {\n        margin: 0 10px;\n        height: 100vh;\n        width: calc(100% - 20px);\n      }\n    }\n\n    .rightGeneralSetting::-webkit-scrollbar {\n      width: 0;\n      height: 0;\n      display: none;\n    }\n\n    .rightGeneralSetting {\n      scrollbar-width: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GeneralSettings": `GeneralSettings_tvmML`,
	"GeneralSettingsContent": `GeneralSettingsContent_p07zs`,
	"leftGeneralSetting": `leftGeneralSetting_XafRE`,
	"disabledOption": `disabledOption_ohK5e`,
	"getPlusOption": `getPlusOption_zi62L`,
	"selected": `selected_RygAl`,
	"rightGeneralSetting": `rightGeneralSetting_GRkNq`
};
export default ___CSS_LOADER_EXPORT___;
